// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

import { useAuth0 } from '@auth0/auth0-react';
import { useAppDispatch } from 'Hooks';
import { Logout } from './authThunk';

// Signing out the same way from every place that offers it. The server ends the session first; then an SSO customer
// leaves through Auth0's sign-out, which ends their Auth0 session too, and everyone else reloads.
// eslint-disable-next-line import/prefer-default-export
export const useLogout = () => {
  const dispatch = useAppDispatch();
  const { logout: auth0Logout, isAuthenticated: isAuth0Authenticated } = useAuth0();
  const leaveThroughAuth0 = () => auth0Logout({ logoutParams: { returnTo: window.location.origin } });

  return () => dispatch(Logout({ leave: isAuth0Authenticated ? leaveThroughAuth0 : undefined }));
};
